import { error as logError } from '@eika-infrastruktur/log';

const checkUrl = async (url: string) => {
    try {
        const response = await fetch(url, { method: 'HEAD' });
        return response.ok && response.status !== 204;
    } catch (error) {
        logError(error);
        return false;
    }
};

export default checkUrl;
